import React, { useEffect } from "react";
import { useInvite } from "../../context/InviteContext";
import Spinner from "../Loader/Spinner";
import XCancel from "../XCancel";
import { Field, Formik } from "formik";
import { initialInviteValues, inviteSchema } from "../../schemas/InviteSchema";
import { TextField } from "formik-mui";

const InviteFriends = ({ close }) => {
  const { sendInvite, loading, loader, done } = useInvite();
  // const hasMore = () => {
  //   return count !== users?.length;
  // };

  const handleSubmit = (values) => {
    sendInvite(values)
  }

  useEffect(() => {
    done && close();
  }, [close, done]);

  useEffect(() => {
    close ? (document.body.style.overflow = "hidden") : (document.body.style.overflow = "unset");
    return () => {
      document.body.style.overflow = "unset";
      document.body.style.overflow = "auto";
    };
  }, [close]);

  return (
    <>
      <XCancel close={close} />
      <div className="px-[60px] pb-[32px] w-[300px] md:w-[536px] h-[auto]">
        <div className="w-full h-full flex flex-col items-center justify-center">
          <p className="text-[#1A1D4D] font-black text-[18px]">Invite Friend</p>
          <div className="w-full flex flex-col items-center justify-center">
            {!loader ? (
              <Formik
                onSubmit={handleSubmit}
                initialValues={initialInviteValues} validationSchema={inviteSchema}
              >
                {({ handleSubmit, values }) => (
                  <div className="w-full flex flex-col items-center justify-center ">
                    <div className="pt-8">
                      <div className="mt-1 relative flex md:justify-end">
                        <Field
                          name={"name"}
                          value={values.name || ""}
                          onKeyDown={(e) => {
                            e.key === "Enter" && handleSubmit();
                          }}
                          label="Name"
                          component={TextField}
                          className="border w-full md:w-[337px] border-primary  rounded px-2  focus:outline-none text-[14px] font-semibold "
                        />
                      </div>
                    </div>
                    <div className="pt-4">
                      <div className="mt-1 relative flex md:justify-end">
                        <Field
                          name={"phone"}
                          value={values.phone || ""}
                          label="Phone"
                          component={TextField}
                          className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                        />
                      </div>
                    </div>

                    <div className="pt-4">
                      <div className="mt-1 relative flex md:justify-end">
                        <Field
                          name={"email"}
                          value={values.email || ""}
                          label="Email"
                          component={TextField}
                          className="border w-full md:w-[337px] border-primary font-Montserrat rounded px-2 focus:outline-none text-[14px] font-semibold"
                        />
                      </div>
                    </div>
                    
                    <button
                      onClick={handleSubmit}
                      className="w-[200px] md:w-[337px] h-[50px] bg-primary rounded mt-8 text-white text-base font-semibold"
                    >
                      {loading ? <Spinner /> : "Send Invite"}{" "}
                    </button>
                  </div>
                )}
              </Formik>
            ) : (
              <div className="mt-6">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default InviteFriends;
